<script>
  import { onMount, tick, getContext } from 'svelte';
  import VisibilityGuard from '@components/VisibilityGuard.svelte';
  import { getCurrentUserStore } from '@stores/current_user';

  import Track from '@utils/track';
  import ComponentEvents from '@utils/component-events';
  import { getGroupStore } from '@stores/group';
  let groupStore = getGroupStore('groupStore');
  let recObjectsStore = getGroupStore('recObjectsStore');
  import { Fancybox } from '@fancyapps/ui';
  import { isEqual } from 'lodash-es';

  import '@fancyapps/ui/dist/fancybox/fancybox.css';

  import { browser } from '$app/environment';

  import 'owl.carousel.es6/dist/assets/owl.carousel.css';
  import placeholderRect from '@images/placeholder-rect.png';
  import placeholderSquare from '@images/placeholder-square.png';
  import jQuery from 'jquery';

  const SLOTS = $$props.$$slots;
  let isChromeExtension = getContext('chromeExtension');
  export let recObjectId = null;
  export let mobile = false;
  export let viewStyle = 'list';
  export let maxBigDotsShown = mobile ? 7 : 14;
  export let useCarousel = true;
  export let viewContext = null;
  export let spotlightUser = null;
  export let pinnedGroup = null;
  export let showNav = true;
  // defaults to true
  export let useFancyBox = !isChromeExtension;
  export let photosStyle = '';
  export let extraIdentifier = '';
  export let photos = [];
  export let loop = false;
  export let startPosition = 0;
  export let customGroupStore;
  export let preventDefaultClick = false;
  export let autoHeight = false;
  export let autoWidth = true;
  export let alwaysVisible = false;

  let brokenLink = false;

  export let afterOwlCarouselSetup = () => {};

  $: if (photos) {
    refresh += 1;
  }

  let group = customGroupStore || groupStore;
  let recObject = recObjectId ? recObjectsStore.find(recObjectId) : null;

  $: if (recObject) {
    brokenLink = recObject.weblink_broken;
  }

  let currentUser = getCurrentUserStore('default');
  let refresh = 1;
  let owlEl;

  let sortPhotos = function () {
    if (recObject) {
      let sortOrder = recObject.photos_sort_order.map((x) => {
        return parseInt(x);
      });

      photos = recObject.rec_object_photos.sort(function (a, b) {
        return sortOrder.indexOf(a.id) - sortOrder.indexOf(b.id);
      });
    }
  };

  let fixBrokenOwl = async function () {
    if (!browser) {
      return;
    }

    await tick();

    if (owlEl && jQuery(owlEl).children('a[rel]').length > 0) {
      refresh += 1;
    }
  };

  let owlCarousel;
  let carouselNode;
  let currentIndex = 0;
  let previousIndex = 0;

  let trackPhotoClick = function (photo) {
    if (viewContext != 'embed-post-carousel') {
      Track.photoClicked({
        group,
        recObject,
        photo,
        user: currentUser,
      });
    }
  };

  let removeAllDotClasses = function (jqElem) {
    return jqElem.removeClass('zoom-small').removeClass('zoom-smallest');
  };

  let drawDots = function (owlCarousel, start, end) {
    var i = 0;
    owlCarousel.find('.owl-dot').each(function () {
      if (i >= start && i < end) {
        jQuery(this).show().removeClass('zoom-small', 50, 'linear').removeClass('zoom-smallest', 50, 'linear');
      } else if (i == start - 1 || i == end) {
        removeAllDotClasses(jQuery(this)).addClass('zoom-small').show();
      } else if (i == start - 2 || i == end + 1) {
        removeAllDotClasses(jQuery(this)).addClass('zoom-smallest').show();
      } else {
        removeAllDotClasses(jQuery(this)).hide();
      }

      i += 1;
    });
  };

  let setupDots = function (owlCarousel, forced = false) {
    var start = currentIndex - maxBigDotsShown + 1;

    if (currentIndex < previousIndex) {
      start = currentIndex;
    }

    var end = start + maxBigDotsShown;
    var active = jQuery(owlCarousel.find('.owl-dot.active'));

    if (start < 0) {
      start = 0;
      end = start + maxBigDotsShown;
    }

    if (active && active.length == 1 && (active.hasClass('zoom-small') || active.hasClass('zoom-smallest'))) {
      setTimeout(function () {
        drawDots(owlCarousel, start, end);
      }, 100);
    }

    if (forced) {
      drawDots(owlCarousel, start, end);
    }
  };

  let muteAllSpotlightVideoPlayers = function () {
    const videoPlayers = document.querySelectorAll('.js-spotlight-video-player');
    videoPlayers.forEach((player) => {
      player.muted = true;
    });
  };

  let setupOwlCarousel = async function (node) {
    if (!browser) {
      return;
    }
    await import('@utils/owl-carousel');

    owlEl = node;

    let setup = function () {
      if (useCarousel == false) {
        return;
      }

      if (node) {
        carouselNode = node;
      }

      owlCarousel = jQuery(carouselNode);
      var changedCall = false;

      owlCarousel.owlCarousel({
        loop: loop,
        autoWidth: autoWidth,
        autoHeight: autoHeight,
        stagePadding: 1,
        navText: ["<i class='fas fa-angle-left'></i>", "<i class='fas fa-angle-right' style='padding-left: 2px'></i>"],
        responsive: {
          0: {
            items: 1,
            nav: false,
            autoWidth: false,
            stagePadding: 0,
          },
          768: {
            items: viewStyle == 'grid' || viewContext == 'embed-post-carousel' ? 1 : 2,
            nav: showNav,
          },
        },
        startPosition: startPosition,
      });

      setupDots(owlCarousel, true);

      owlCarousel.on('changed.owl.carousel', function (event) {
        previousIndex = currentIndex;
        currentIndex = event.item.index;
        setupDots(owlCarousel);
        if (viewContext == 'spotlight-carousel') {
          muteAllSpotlightVideoPlayers();
          Track.spotlightNextImage({
            currentUser: currentUser,
            user: spotlightUser,
            path: location.pathname,
          });
        } else {
          if (viewContext == 'spotlight-list-carousel') {
            Track.spotlightListNextImage({
              currentUser: currentUser,
              user: spotlightUser,
              path: location.pathname,
              groupBase: pinnedGroup,
            });
          } else {
            if (viewContext == 'embed-post-carousel') {
              console.log(event.item);
              Track.embedPostNextImage({
                currentUser: currentUser,
                group: pinnedGroup,
                link: photos[event.item.index]?.view_urls?.full_size,
                numScreens: photos.length,
              });
            } else {
              if (changedCall == true) {
                Track.photoChanged({
                  user: currentUser,
                  group,
                  recObject,
                  photo: photos[event.item.index],
                });
              }
            }
          }
        }

        changedCall = true;
      });

      // disable scroll
      owlCarousel.on('drag.owl.carousel', function () {
        document.ontouchmove = function (e) {
          e.preventDefault();
        };
      });

      // enable scroll
      owlCarousel.on('dragged.owl.carousel', function () {
        document.ontouchmove = function () {
          return true;
        };
      });

      setupDots(owlCarousel);
      afterOwlCarouselSetup(owlCarousel);
    };

    setup();
  };

  let showFancyBox = function (index = 0) {
    if (useFancyBox) {
      Fancybox.show(
        photos.map((p) => {
          return {
            src: p.view_urls.full_size,
            type: 'image',
          };
        }),
        {
          infinite: false,
          startIndex: index,
          on: {
            'Carousel.change': (fb, c, slide) => {
              Track.photoChanged({
                user: currentUser,
                group,
                recObject,
                photo: photos[slide],
              });
            },
          },
        }
      );
    }
  };

  let showPlaceholderImage = (e) => {
    e.target.src = '/images/grid-no-photo.png';
  };

  sortPhotos();
  onMount(() => {
    let unsubRecObject = recObject
      ? recObject.subscribe((ro, prev) => {
          if (prev && !isEqual(ro.rec_object_photos, prev.rec_object_photos)) {
            recObject = ro;
            sortPhotos();
          }

          fixBrokenOwl();
        })
      : () => {};

    let unsubRefreshPhotos = ComponentEvents.on('refresh-broken-owl', fixBrokenOwl);

    return () => {
      unsubRecObject();
      unsubRefreshPhotos();
    };
  });
</script>

<style style="text/scss" lang="scss">
  @import '../../../vendor/design-system.scss';

  .ui-single-photo {
    margin-top: 25px;

    :global(.ui-photo) {
      max-height: 298px;
      width: 430px;
      border-radius: 15px;
      height: 275px;
      max-width: 450px;
      cursor: pointer;
    }
  }

  .ui-photos {
    margin-top: 25px;
    margin-bottom: 20px;

    :global(.ui-photo) {
      cursor: pointer;
      width: 180px;
      height: 180px;
      margin-right: 18px;
      border-radius: 15px;
    }
  }

  .mobile {
    .ui-single-photo {
      :global(.ui-photo) {
        width: 100% !important;
        height: unset !important;
        display: block;
        margin-left: auto;
        margin-right: auto;
      }
    }

    .ui-photos {
      :global(.ui-photo) {
        width: 275px !important;
        height: 180px !important;
      }
    }
  }

  .grid {
    .ui-single-photo {
      margin-top: 16px !important;
      &.broken-link {
        :global(.ui-photo) {
          height: 178px !important;
        }
      }
      :global(.ui-photo) {
        height: 210px !important;
        width: 280px !important;
        max-height: 210px !important;
        max-width: 280px !important;
      }
    }

    .ui-photos {
      margin-top: 0px !important;
      margin-bottom: 8px !important;

      &.broken-link {
        :global(.ui-photo) {
          height: 168px !important;
        }
      }
      :global(.ui-photo) {
        width: 280px !important;
        height: 200px !important;
        max-height: 200px !important;
        max-width: 280px !important;
      }
    }
  }

  .grid.mobile {
    .ui-single-photo {
      margin-top: 0px !important;

      :global(.ui-photo) {
        width: 100% !important;
        height: 180px !important;
        display: block;
        margin-left: auto;
        margin-right: auto;
        max-height: 180px !important;
        max-width: 275px !important;
      }
    }

    .ui-photos {
      margin-top: 0px !important;
      margin-bottom: 8px !important;

      :global(.ui-photo) {
        height: 180px !important;
        width: 236px !important;
        max-height: 180px !important;
        max-width: 236px !important;
      }
    }
  }

  .mobile-detail-view {
    .ui-single-photo {
      margin-top: 16px !important;

      :global(.ui-photo) {
        height: 112px !important;
        width: 150px !important;
        max-height: 112px !important;
        max-width: 150px !important;
      }
    }

    .ui-photos {
      margin-top: 0px !important;
      margin-bottom: 8px !important;

      :global(.ui-photo) {
        height: 112px !important;
        width: 150px !important;
        max-height: 112px !important;
        max-width: 150px !important;
      }
    }
  }

  .low-res-container-single {
    position: absolute;
    height: 24px;
    bottom: 0px;
    left: 0px;
    right: 2px;
    background: rgba(0, 0, 0, 0.6);
    color: rgb(255, 183, 104);
    display: flex;
    align-items: center;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;

    .low-res-text {
      font-size: 12px;
      line-height: 16px;
      font-weight: bold;
      margin-left: 10px;
    }

    svg {
      margin-left: 8px;
    }
  }

  .low-res-container {
    position: absolute;
    height: 24px;
    bottom: 0px;
    left: 4px;
    right: 18px;
    background: rgba(0, 0, 0, 0.6);
    color: rgb(255, 183, 104);
    display: flex;
    align-items: center;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;

    .low-res-text {
      font-size: 12px;
      line-height: 16px;
      font-weight: bold;
      margin-left: 10px;
    }

    svg {
      margin-left: 8px;
    }
  }

  .ui-single-photo.contain {
    .ui-photo {
      object-fit: contain;
      background-color: $neutral-white;
    }
  }

  .owl-carousel.ssr-loaded {
    display: block; /* Hide by default */
    .ui-photo-wrapper {
      display: none;
    }

    .ui-photo-wrapper:first-child {
      display: block;
    }
  }
</style>

<div class:mobile={mobile} class={viewStyle}>
  {#if photos.length == 0 && viewStyle == 'grid'}
    <div class="ui-single-photo {brokenLink ? 'broken-link' : 'regular'}">
      <img
        class="ui-photo"
        src="/images/grid-no-photo.png"
        style={mobile
          ? 'width: 100% !important; max-width: unset !important; border-radius: 0px; min-height: 250px;'
          : ''} />
    </div>
  {:else if photos.length == 1}
    <VisibilityGuard let:hasBeenVisible>
      {#if hasBeenVisible || alwaysVisible}
        <div class="ui-single-photo {brokenLink ? 'broken-link' : 'regular'} {photos[0].display_style}">
          <a
            on:click={(e) => {
              if (preventDefaultClick) {
                e.preventDefault();
              }

              showFancyBox();
              trackPhotoClick(photos[0]);
            }}
            data-fancybox={useFancyBox ? `gallery-${extraIdentifier}-${recObject && recObject.id}` : null}
            href={!browser && preventDefaultClick ? 'javascript:void(0)' : photos[0].view_urls.full_size}
            rel={`gallery-${extraIdentifier}-${recObject && recObject.id}`}>
            {#if SLOTS && SLOTS.img}
              <slot
                name="img"
                photo={photos[0]}
                showPlaceholderImage={showPlaceholderImage}
                index={0}
                currentIndex={0} />
            {:else}
              <img
                class="ui-photo"
                style={photos[0].background_color ? `background-color: ${photos[0].background_color} !important;` : ''}
                on:error={showPlaceholderImage}
                src={photos[0].view_urls.rect_size || photos[0].view_urls.full_size}
                alt={recObject && recObject.display_name ? `${recObject.display_name}` : ''} />
            {/if}
            {#if photos[0].lowRes}
              <div class="low-res-container-single">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="12" height="12">
                    <rect width="12" height="12" fill="white" />
                  </mask>
                  <g mask="url(#mask0)">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M6.92398 0.383219C6.41311 -0.127739 5.58483 -0.12774 5.07396 0.383218L0.383154 5.07483C-0.127717 5.58579 -0.127718 6.41421 0.383152 6.92517L5.07396 11.6168C5.58483 12.1277 6.41311 12.1277 6.92398 11.6168L11.6148 6.92517C12.1257 6.41421 12.1257 5.58579 11.6148 5.07483L6.92398 0.383219ZM6.10449 3.05636C6.28803 3.05636 6.46406 3.12987 6.59384 3.26074C6.72363 3.3916 6.79654 3.56909 6.79654 3.75416C6.79654 3.86846 6.79688 3.95803 6.79717 4.03321C6.79758 4.13792 6.79787 4.21471 6.79698 4.29149C6.79452 4.5026 6.78305 4.71362 6.74006 5.50487C6.72288 5.82111 6.70066 6.23003 6.67197 6.76869C6.67197 6.92323 6.61109 7.07143 6.50272 7.1807C6.39435 7.28998 6.24736 7.35136 6.09411 7.35136C5.94085 7.35136 5.79386 7.28998 5.68549 7.1807C5.57712 7.07143 5.51624 6.92323 5.51624 6.76869C5.48661 6.21665 5.46388 5.80269 5.44648 5.48566C5.40549 4.73912 5.39401 4.52998 5.39135 4.32072C5.39032 4.23928 5.39062 4.15783 5.39104 4.04467C5.39133 3.96646 5.39167 3.87311 5.39167 3.75416C5.39163 3.66074 5.4102 3.56825 5.44627 3.4822C5.48234 3.39614 5.53518 3.31827 5.60166 3.25319C5.66813 3.18811 5.74689 3.13715 5.83327 3.10334C5.91964 3.06953 6.01187 3.05355 6.10449 3.05636ZM6.10449 9.28778C5.9549 9.28709 5.80887 9.24178 5.68478 9.15755C5.5607 9.07333 5.46411 8.95396 5.40718 8.81448C5.35025 8.675 5.33554 8.52166 5.36489 8.37376C5.39424 8.22587 5.46634 8.09004 5.57211 7.98339C5.67788 7.87674 5.81259 7.80404 5.95926 7.77444C6.10594 7.74485 6.25802 7.75969 6.39635 7.81709C6.53468 7.87449 6.65306 7.97188 6.73659 8.097C6.82012 8.22212 6.86506 8.36937 6.86574 8.52019C6.8662 8.62112 6.84682 8.72114 6.80873 8.81448C6.77063 8.90782 6.71458 8.99262 6.6438 9.06399C6.57302 9.13536 6.48892 9.19188 6.39635 9.23029C6.30378 9.2687 6.20458 9.28824 6.10449 9.28778Z"
                      fill="url(#paint0_angular)" />
                  </g>
                  <defs>
                    <radialGradient
                      id="paint0_angular"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(5.99897 6) rotate(44.9951) scale(8.48601 8.48746)">
                      <stop offset="0.745949" stop-color="#FFDAAF" />
                      <stop offset="0.75" stop-color="#FFB768" />
                    </radialGradient>
                  </defs>
                </svg>
                <div class="low-res-text">Low resolution</div>
              </div>
            {/if}
          </a>
        </div>
      {:else}
        <div class="ui-single-photo {brokenLink ? 'broken-link' : 'regular'}">
          <img class="ui-photo" src={placeholderRect} alt="placeholder" />
        </div>
      {/if}
    </VisibilityGuard>
  {:else if photos.length > 1}
    <VisibilityGuard let:hasBeenVisible>
      {#if hasBeenVisible || alwaysVisible}
        {#each [refresh] as refresh (refresh)}
          <div
            class:owl-carousel={useCarousel}
            class:owl-theme={useCarousel}
            class:is-mobile={mobile}
            class="ui-photos {brokenLink ? 'broken-link' : 'regular'} {browser ? '' : 'ssr-loaded'}"
            style={photosStyle}
            use:setupOwlCarousel>
            {#each photos as photo, idx (photo.view_urls)}
              <a
                on:click={(e) => {
                  if (preventDefaultClick) {
                    e.preventDefault();
                  }

                  showFancyBox(idx);
                  trackPhotoClick(photo);
                }}
                class="ui-photo-wrapper"
                data-fancybox={useFancyBox ? `gallery-${extraIdentifier}-${recObject && recObject.id}` : null}
                href={!browser && preventDefaultClick ? 'javascript:void(0)' : photo.view_urls.full_size}
                rel={`gallery-${extraIdentifier}-${recObject && recObject.id}`}>
                {#if SLOTS && SLOTS.img}
                  <slot name="img" photo={photo} index={idx} currentIndex={currentIndex} />
                {:else if mobile || viewStyle == 'grid'}
                  <img
                    style={photo.background_color ? `background-color: ${photo.background_color} !important;` : ''}
                    class={`ui-photo ${photo.display_style}`}
                    alt={recObject && recObject.display_name
                      ? `${recObject.display_name} - Photo ${idx + 1}`
                      : `rec-${idx}`}
                    on:error={showPlaceholderImage}
                    src={photo.view_urls.rect_size || photo.view_urls.full_size} />
                {:else}
                  <img
                    style={photo.background_color ? `background-color: ${photo.background_color} !important;` : ''}
                    class={`ui-photo ${photo.display_style}`}
                    alt={recObject && recObject.display_name
                      ? `${recObject.display_name} - Photo ${idx + 1}`
                      : `rec-${idx}`}
                    on:error={showPlaceholderImage}
                    src={photo.view_urls.square_size || photo.view_urls.full_size} />
                {/if}

                {#if photo.lowRes}
                  <div class="low-res-container">
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="12" height="12">
                        <rect width="12" height="12" fill="white" />
                      </mask>
                      <g mask="url(#mask0)">
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M6.92398 0.383219C6.41311 -0.127739 5.58483 -0.12774 5.07396 0.383218L0.383154 5.07483C-0.127717 5.58579 -0.127718 6.41421 0.383152 6.92517L5.07396 11.6168C5.58483 12.1277 6.41311 12.1277 6.92398 11.6168L11.6148 6.92517C12.1257 6.41421 12.1257 5.58579 11.6148 5.07483L6.92398 0.383219ZM6.10449 3.05636C6.28803 3.05636 6.46406 3.12987 6.59384 3.26074C6.72363 3.3916 6.79654 3.56909 6.79654 3.75416C6.79654 3.86846 6.79688 3.95803 6.79717 4.03321C6.79758 4.13792 6.79787 4.21471 6.79698 4.29149C6.79452 4.5026 6.78305 4.71362 6.74006 5.50487C6.72288 5.82111 6.70066 6.23003 6.67197 6.76869C6.67197 6.92323 6.61109 7.07143 6.50272 7.1807C6.39435 7.28998 6.24736 7.35136 6.09411 7.35136C5.94085 7.35136 5.79386 7.28998 5.68549 7.1807C5.57712 7.07143 5.51624 6.92323 5.51624 6.76869C5.48661 6.21665 5.46388 5.80269 5.44648 5.48566C5.40549 4.73912 5.39401 4.52998 5.39135 4.32072C5.39032 4.23928 5.39062 4.15783 5.39104 4.04467C5.39133 3.96646 5.39167 3.87311 5.39167 3.75416C5.39163 3.66074 5.4102 3.56825 5.44627 3.4822C5.48234 3.39614 5.53518 3.31827 5.60166 3.25319C5.66813 3.18811 5.74689 3.13715 5.83327 3.10334C5.91964 3.06953 6.01187 3.05355 6.10449 3.05636ZM6.10449 9.28778C5.9549 9.28709 5.80887 9.24178 5.68478 9.15755C5.5607 9.07333 5.46411 8.95396 5.40718 8.81448C5.35025 8.675 5.33554 8.52166 5.36489 8.37376C5.39424 8.22587 5.46634 8.09004 5.57211 7.98339C5.67788 7.87674 5.81259 7.80404 5.95926 7.77444C6.10594 7.74485 6.25802 7.75969 6.39635 7.81709C6.53468 7.87449 6.65306 7.97188 6.73659 8.097C6.82012 8.22212 6.86506 8.36937 6.86574 8.52019C6.8662 8.62112 6.84682 8.72114 6.80873 8.81448C6.77063 8.90782 6.71458 8.99262 6.6438 9.06399C6.57302 9.13536 6.48892 9.19188 6.39635 9.23029C6.30378 9.2687 6.20458 9.28824 6.10449 9.28778Z"
                          fill="url(#paint0_angular)" />
                      </g>
                      <defs>
                        <radialGradient
                          id="paint0_angular"
                          cx="0"
                          cy="0"
                          r="1"
                          gradientUnits="userSpaceOnUse"
                          gradientTransform="translate(5.99897 6) rotate(44.9951) scale(8.48601 8.48746)">
                          <stop offset="0.745949" stop-color="#FFDAAF" />
                          <stop offset="0.75" stop-color="#FFB768" />
                        </radialGradient>
                      </defs>
                    </svg>
                    <div class="low-res-text">Low resolution</div>
                  </div>
                {/if}
              </a>
            {/each}
          </div>
        {/each}
      {:else}
        <div class="ui-photos owl-carousel owl-theme {brokenLink ? 'broken-link' : 'regular'}" use:setupOwlCarousel>
          {#if mobile}
            <img class="ui-photo" src={placeholderRect} alt="placeholder" />
          {:else}
            {#each photos as _photo}
              <img class="ui-photo" src={placeholderSquare} alt="placeholder" />
            {/each}
          {/if}
        </div>
      {/if}
    </VisibilityGuard>
  {/if}
</div>
